import React, { useRef, useState } from "react";

const BillingDTR = () => {
  const formRef = useRef();
  // ---------- INBOUND DATA ----------
  const [inbound, setInbound] = useState({
    slNo: "DTR-001",
    date: "2025-11-20",
    clientName: "AgroBuild Pvt. Ltd.",
    warehouseName: "GrainVault Storage",
    commodity: "Wheat",
    variety: "Sharbati",
    totalTrucks: "5",
    crdOrCdd: "CRD-7781",
    inwardBags: "1200",
    inwardQty: "60.50",
    spillageBags: "5",
    closingBags: "1195",
    closingQty: "60.20",
    remarks: "Smooth inward process.",
  });

  // ---------- OUTBOUND DATA ----------
  const [outbound, setOutbound] = useState({
    slNo: "DTR-001",
    date: "2025-11-20",
    clientName: "AgroBuild Pvt. Ltd.",
    warehouseName: "GrainVault Storage",
    commodity: "Wheat",
    variety: "Sharbati",
    totalTrucks: "4",
    crdOrCdd: "CD-9982",
    outwardBags: "1180",
    outwardQty: "59.80",
    spillageBags: "2",
    closingBags: "1183",
    closingQty: "59.55",
    remarks: "Outbound completed with minor spillage.",
  });

  const handlePrint = () => {
    const printContents = formRef.current.innerHTML;
    const printWindow = window.open("", "_blank", "width=900,height=650");
    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>Print CRD</title>
                <style>
                    body { font-family: Arial; padding: 20px; }
                    table { width: 100%; border-collapse: collapse; }
                    table td, table th { border: 1px solid #000; padding: 6px; }
                    h2, h3 { text-align: center; }
                </style>
            </head>
            <body>${printContents}</body>
        </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  // ---------- TABLE ROW BUILDER ----------
  const renderRow = (label, inboundValue, outboundValue) => {
    const highlight =
      inboundValue !== outboundValue ? { background: "#fff3cd" } : {};

    return (
      <tr style={highlight}>
        <td className="fw-semibold">{label}</td>
        <td>{inboundValue || "-"}</td>
        <td>{outboundValue || "-"}</td>
      </tr>
    );
  };

  return (
    <div className="container">
      <div className="card shadow-sm border-0 rounded-3">
        {/* ref start */}
        <div ref={formRef}>
          <div className="card-body p-4">
            <h3 className="text-center mb-4 fw-bold">
              Daily Transaction Report (DTR)
            </h3>

            <table
              className="table table-bordered table-striped"
              style={{ width: "45rem", marginLeft: "15rem" }}
            >
              <thead className="table-dark">
                <tr>
                  <th>Field</th>
                  <th>Inbound</th>
                  <th>Outbound</th>
                </tr>
              </thead>

              <tbody>
                {renderRow("SL No.", inbound.slNo, outbound.slNo)}
                {renderRow("Date", inbound.date, outbound.date)}
                {renderRow(
                  "Client Name",
                  inbound.clientName,
                  outbound.clientName
                )}
                {renderRow(
                  "Warehouse Name",
                  inbound.warehouseName,
                  outbound.warehouseName
                )}
                {renderRow("Commodity", inbound.commodity, outbound.commodity)}
                {renderRow("Variety", inbound.variety, outbound.variety)}
                {renderRow(
                  "Total Trucks/Containers",
                  inbound.totalTrucks,
                  outbound.totalTrucks
                )}
                {renderRow("CRD/CDD No.", inbound.crdOrCdd, outbound.crdOrCdd)}

                {/* Inward/Outward Fields */}
                {renderRow(
                  "Inward Bags",
                  inbound.inwardBags,
                  outbound.inwardBags
                )}
                {renderRow(
                  "Inward Quantity (MT)",
                  inbound.inwardQty,
                  outbound.inwardQty
                )}
                {renderRow(
                  "Outward Bags",
                  inbound.outwardBags,
                  outbound.outwardBags
                )}
                {renderRow(
                  "Outward Quantity (MT)",
                  inbound.outwardQty,
                  outbound.outwardQty
                )}

                {renderRow(
                  "Spillage Bags",
                  inbound.spillageBags,
                  outbound.spillageBags
                )}
                {renderRow(
                  "Closing Bags",
                  inbound.closingBags,
                  outbound.closingBags
                )}
                {renderRow(
                  "Closing Quantity (MT)",
                  inbound.closingQty,
                  outbound.closingQty
                )}
                {renderRow("Remarks", inbound.remarks, outbound.remarks)}
              </tbody>
            </table>

            <p className="text-muted text-center mt-3">
              <strong>Note:</strong> Highlighted rows indicate differences
              between inbound and outbound.
            </p>
          </div>
        </div>
        {/* ref end */}

        <div className="text-center mb-5">
          <button className="btn btn-primary" onClick={handlePrint}>
            Print Form
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingDTR;
